import React from 'react';
import { StyledTopBar } from './styled';

const Topbar = ({ setOpen }) => {
    const onClickOfCloseButton = () => {
        setOpen(false);
    }

    return (<StyledTopBar>
        <span>Annotations</span>
        <span style={{cursor: 'pointer'}}onClick={onClickOfCloseButton}>X</span>
    </StyledTopBar>);
}

export default Topbar;
